import { Pipe, PipeTransform } from '@angular/core';
import { DVIRStatuses, DVIRStatusesSinglePlural } from '@app/lib/i18n-backend-strings';
import { Session } from '@app/services/session';

@Pipe({
  name: 'dvirStatus',
  pure: true,
})
export class DvirStatusPipe implements PipeTransform {
  public transform(status, defects, isCanadianCycle = false) {
    // TODO: Use enums for statuses and check for DLR statuses as well (MAINT-4116)
    if (status === 'satisfactory' && !defects) {
      if (isCanadianCycle) {
        return DVIRStatuses.no_defect;
      }
      return DVIRStatuses.condition_satisfactory;
    } else if (status === 'harmless') {
      return this.getSingularPluralValue(defects, 'defect_need_to_be_corrected');
    } else if (status === 'corrected') {
      return this.getSingularPluralValue(defects, 'defect_corrected');
    }

    return this.getSingularPluralValue(defects, 'defect_open');
  }

  private getSingularPluralValue(defects, prop): string {
    return defects === 1 ? `${defects} ${DVIRStatusesSinglePlural[prop].singular}` :
      defects > 1 ? `${defects} ${DVIRStatusesSinglePlural[prop].plural}` : DVIRStatusesSinglePlural[prop].singular;
  }
}
